// public
import React from 'react';
import PropTypes from 'prop-types';

import withPresets from '@xingternal/with-presets';
import { mergeStyles } from '@xingternal/merge-styles';

import SuperEllipse from '@xingternal/super-ellipse';
import Badge from '@xingternal/badge';

import base from './ProfileImage.css';

import * as skins from './profile-image-skins';
import {
  xxsmallOnConfined,
  xxsmallOnWide,
} from '@xingternal/super-ellipse/super-ellipse-skins';

const ProfileImage = ({
  connectionDegree,
  xxxxlarge,
  xxxxlargeOnConfined,
  xxxxlargeOnWide,
  xxxlarge,
  xxxlargeOnConfined,
  xxxlargeOnWide,
  xxlarge,
  xxlargeOnConfined,
  xxlargeOnWide,
  xlarge,
  xlargeOnConfined,
  xlargeOnWide,
  large,
  largeOnConfined,
  largeOnWide,
  medium,
  mediumOnConfined,
  mediumOnWide,
  small,
  smallOnConfined,
  smallOnWide,
  xsmall,
  xxsmall,
  xsmallOnConfined,
  xsmallOnWide,
  skin,
  ...props
}) => {
  const styles = mergeStyles(base, skin);

  return (
    <div className={styles.container}>
      <SuperEllipse
        {...{
          xxxxlarge,
          xxxxlargeOnConfined,
          xxxxlargeOnWide,
          xxxlarge,
          xxxlargeOnConfined,
          xxxlargeOnWide,
          xxlarge,
          xxlargeOnConfined,
          xxlargeOnWide,
          xlarge,
          xlargeOnConfined,
          xlargeOnWide,
          large,
          largeOnConfined,
          largeOnWide,
          medium,
          mediumOnConfined,
          mediumOnWide,
          small,
          smallOnConfined,
          smallOnWide,
          xsmall,
          xxsmall,
          xsmallOnConfined,
          xsmallOnWide,
          skin: styles,
          ...props,
        }}
      />
      {connectionDegree && (
        <Badge
          large={xlarge || xxlarge || xxxlarge || xxxxlarge}
          largeOnConfined={
            xlargeOnConfined ||
            xxlargeOnConfined ||
            xxxlargeOnConfined ||
            xxxxlargeOnConfined
          }
          largeOnWide={
            xlargeOnWide || xxlargeOnWide || xxxlargeOnWide || xxxxlargeOnWide
          }
          medium={medium || large}
          mediumOnConfined={mediumOnConfined || largeOnConfined}
          mediumOnWide={mediumOnWide || largeOnWide}
          small={xxsmall || xsmall || small}
          smallOnConfined={
            xxsmallOnConfined || xsmallOnConfined || smallOnConfined
          }
          smallOnWide={xxsmallOnWide || xsmallOnWide || smallOnWide}
          connectionDegree
          skin={styles}
        >
          {connectionDegree}
        </Badge>
      )}
    </div>
  );
};

ProfileImage.propTypes = {
  /** connection degree value */
  connectionDegree: PropTypes.number,
  /** add you own styles */
  skin: PropTypes.object,
  /** add the profile name */
  profileName: PropTypes.string,
  /** The src attribute for the img element. */
  src: PropTypes.string,
  /** 	Used to render icon inside the Avatar. If there is no src  props will not be used and no img will be rendered by default.
This can be  just a string.
 */
  type: PropTypes.oneOf([
    'female-user',
    'male-user',
    'neutral-user',
    'company',
  ]),
  /** In order to write good alt test try to describe the image as specifically as possible. Don't use the src of the images as a text or profile name  */
  alt: PropTypes.string,
  /** @ignore */
  xxxxlarge: PropTypes.bool,
  /** @ignore */
  xxxxlargeOnConfined: PropTypes.bool,
  /** @ignore */
  xxxxlargeOnWide: PropTypes.bool,
  /** @ignore */
  xxxlarge: PropTypes.bool,
  /** @ignore */
  xxxlargeOnConfined: PropTypes.bool,
  /** @ignore */
  xxxlargeOnWide: PropTypes.bool,
  /** @ignore */
  xxlarge: PropTypes.bool,
  /** @ignore */
  xxlargeOnConfined: PropTypes.bool,
  /** @ignore */
  xxlargeOnWide: PropTypes.bool,
  /** @ignore */
  xlarge: PropTypes.bool,
  /** @ignore */
  xlargeOnConfined: PropTypes.bool,
  /** @ignore */
  xlargeOnWide: PropTypes.bool,
  /** @ignore */
  large: PropTypes.bool,
  /** @ignore */
  largeOnConfined: PropTypes.bool,
  /** @ignore */
  largeOnWide: PropTypes.bool,
  /** @ignore */
  medium: PropTypes.bool,
  /** @ignore */
  mediumOnConfined: PropTypes.bool,
  /** @ignore */
  mediumOnWide: PropTypes.bool,
  /** @ignore */
  small: PropTypes.bool,
  /** @ignore */
  smallOnConfined: PropTypes.bool,
  /** @ignore */
  smallOnWide: PropTypes.bool,
  /** @ignore */
  xsmall: PropTypes.bool,
  /** @ignore */
  xsmallOnConfined: PropTypes.bool,
  /** @ignore */
  xsmallOnWide: PropTypes.bool,
  /** @ignore */
  xxsmall: PropTypes.bool,
};
export default withPresets(skins, true)(ProfileImage);
